import React, { useState } from 'react';
import './AddSiteModal.css'; // Reuse same modal styles

function EditEmployeeModal({ employee, onSave, onClose }) {
  const [name, setName] = useState(employee.name || '');
  const [title, setTitle] = useState(employee.title || '');
  const [department, setDepartment] = useState(employee.department || '');
  const [email, setEmail] = useState(employee.email || '');
  const [phone, setPhone] = useState(employee.phone || '');
  const [extension, setExtension] = useState(employee.extension || '');
  const [photoOption, setPhotoOption] = useState(
    employee.photo ? (employee.photo.startsWith('data:') ? 'upload' : 'url') : 'placeholder'
  );
  const [photoUrl, setPhotoUrl] = useState(
    employee.photo && !employee.photo.startsWith('data:') ? employee.photo : ''
  );
  const [photoPreview, setPhotoPreview] = useState(
    employee.photo && employee.photo.startsWith('data:') ? employee.photo : null
  );
  const [photoData, setPhotoData] = useState(
    employee.photo && employee.photo.startsWith('data:') ? employee.photo : null
  );

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
        setPhotoData(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (name.trim()) {
      let photo = null;
      if (photoOption === 'upload' && photoData) {
        photo = photoData;
      } else if (photoOption === 'url' && photoUrl) {
        photo = photoUrl;
      }
      
      onSave({
        ...employee,
        name: name.trim(),
        title: title.trim() || null,
        department: department.trim() || null,
        email: email.trim() || null,
        phone: phone.trim() || null,
        extension: extension.trim() || null,
        photo: photo
      });
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Employee</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="employee-name">Full Name *</label>
            <input
              type="text"
              id="employee-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., John Smith"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee-title">Job Title</label>
            <input
              type="text"
              id="employee-title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., Senior Developer"
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee-department">Department</label>
            <input
              type="text"
              id="employee-department"
              value={department}
              onChange={(e) => setDepartment(e.target.value)}
              placeholder="e.g., Engineering"
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee-email">Email</label>
            <input
              type="email"
              id="employee-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g., john@company.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee-phone">Phone</label>
            <input
              type="tel"
              id="employee-phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="e.g., (555) 123-4567"
            />
          </div>

          <div className="form-group">
            <label htmlFor="employee-extension">Extension</label>
            <input
              type="text"
              id="employee-extension"
              value={extension}
              onChange={(e) => setExtension(e.target.value)}
              placeholder="e.g., 1234"
            />
          </div>

          <div className="form-group">
            <label>Photo</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '10px', alignItems: 'flex-start' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="photo-option"
                  value="placeholder"
                  checked={photoOption === 'placeholder'}
                  onChange={(e) => setPhotoOption(e.target.value)}
                />
                Use placeholder (first letter)
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="photo-option"
                  value="url"
                  checked={photoOption === 'url'}
                  onChange={(e) => setPhotoOption(e.target.value)}
                />
                Image URL
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="photo-option"
                  value="upload"
                  checked={photoOption === 'upload'}
                  onChange={(e) => setPhotoOption(e.target.value)}
                />
                Upload photo
              </label>
            </div>
            
            {photoOption === 'url' && (
              <input
                type="url"
                id="photo-url"
                value={photoUrl}
                onChange={(e) => setPhotoUrl(e.target.value)}
                placeholder="e.g., https://example.com/photo.jpg"
              />
            )}
            
            {photoOption === 'upload' && (
              <>
                <input
                  type="file"
                  id="employee-photo"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="file-input"
                />
                {photoPreview && (
                  <div className="image-preview">
                    <img src={photoPreview} alt="Photo preview" />
                  </div>
                )}
              </>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditEmployeeModal;
